export const SET_WALLETCONNECT_URI = 'SET_WALLETCONNECT_URI'

export const SET_ISCONNECT_WITH_WALLECT = 'SET_ISCONNECT_WITH_WALLECT'

export const setWalletConnectURI = data => dispatch =>
  dispatch({
    type: SET_WALLETCONNECT_URI,
    data,
  })

export const setIsconnectedWithWallet = data => dispatch =>
  dispatch({
    type: SET_ISCONNECT_WITH_WALLECT,
    data,
  })
